import { gql } from '@apollo/client';

const UserInfoPublic = gql`
  fragment UserInfoPublic on User {
    id
    firstName
    lastName
    email
    phone
    imageUrl
    account {
      id
      accountNumber
      patients {
        id
        firstName
        lastName
        arches
        dob
        birthDay
        birthMonth
        birthYear
      }
    }
    lastLoginAt
    createdAt
    updatedAt
  }
`;

export default UserInfoPublic;
